module.exports = __webpack_public_path__ + "img/tick-square.de9bdd15.svg";